/// <reference types="react" />
import { IFolderItem, IChildItem } from "DistributedTaskControls/SharedControls/Folders/Types";

import * as PipelineTypes from "PipelineWorkflow/Scripts/Common/Types";

export interface IDefinitionEntry extends IChildItem {
    lastRelease: PipelineTypes.PipelineReference;
    lastReleaseCreatedOn: string;
    isFavorite: boolean;
    favoriteId: string;
    path: string;
    canEditReleaseDefinition: boolean;
    canViewReleaseDefinition: boolean;
    canExportReleaseDefinition: boolean;
    canCreateRelease: boolean;
    canDeleteReleaseDefinition: boolean;
    canManagePermissions: boolean;
}

export interface IFolderEntry extends IFolderItem {
    canEdit?: boolean;
    canDelete?: boolean;
    canManagePermissions?: boolean;
}